/**
 * Daten der Hülle: Marken, Themes, Neu-Menü, Konto-Menü, Logobalken.
 *
 * Was hier **nicht** mehr steht, ist der Punkt: Personas, Glockenmeldungen
 * und aktive Nutzer waren erfundene Bestände. Sie sind einzeln entfallen,
 * als es für jede eine Quelle gab — die Glocke am 25.08.2026, die
 * Anwesenheit am 14.08.2026, der angemeldete Nutzer am 27.08.2026. Jede
 * Stelle nennt unten den Grund.
 */

import { INSTANZ_MANDANT } from './instanz';
import { PROFILE } from './navigation';

/* `ICH` und `PERSONA_HINWEIS` sind am 27.08.2026 entfallen.

   `ICH` fuehrte fuenf erfundene Personen mit Namen und Adressen — und die
   Kopfzeile wie `/profil` lasen sie **ohne jeden Rueckfall** auf
   `/api/ich`. Beim Kunden stand unter der Ueberschrift „Stammdaten"
   dauerhaft „Lennart Ahrens · lennart.ahrens@beispiel.invalid" — ein
   Name, den es nirgends gibt, an der einen Stelle der Anwendung, an der
   jeder seinen eigenen erwartet.

   Kopfzeile und Profil lesen jetzt ausschliesslich `/api/ich`. Faellt der
   Abruf aus, steht das da; ein Name wird nicht erfunden.

   Der Personenumschalter des Demobaus bleibt — er wechselt dort das
   **Konto**, und die Namen dazu kommen vom Server. Seine Liste steht in
   `entwurf/demo.ts` als `DEMO_PERSONAS`. */

/* Die vier erfundenen Meldungen der Glocke sind am 25.08.2026 entfallen.

   Sie standen hier als `MELDUNGEN`: „Mira Engler beantragt SAP ERP ·
   Adminrecht fuer sich selbst", „Hanno Gerste vereint Bestellung anlegen und
   Rechnung freigeben" — erfundene Personennamen in einem Mandanten, der
   ausdruecklich **keine Personen fuehrt**, dazu Zeitangaben („vor 8 Min"),
   die seit dem ersten Start dieselben waren. Es ist dieselbe Klasse wie das
   erfundene Audit-Log vom 13.08.2026, nur an der Stelle, an der man sie am
   ehesten fuer bare Muenze nimmt: eine Glocke kuendigt an, dass etwas
   passiert ist.

   Was die Glocke jetzt zeigt, kommt aus `api/meldungen.ts` — drei
   serverseitige Zaehler. Ist nichts offen, sagt sie das. */

/** Aktive Nutzer in der Kopfzeile. */
/* `PRESENCE` und `PRESENCE_REST` standen hier: sechs erfundene Personen mit
   Kuerzel, Seite und Uhrzeit, dazu „+10 weitere". Die Kopfzeile zeigte sie
   dauerhaft oben rechts als „gerade aktiv". Erfunden war alles daran — die
   Namen, die Seiten, die Zeiten und die Zehn. Entfallen am 14.08.2026.
   Wer wirklich angemeldet ist, steht unter `/aktive-nutzer`. */

/**
 * Aufklappliste am „Neu"-Knopf (8.2). `form:` öffnet den Drawer,
 * `wegweiser` den Wegweiser, alles andere ist ein Pfad.
 */
/* Das dritte Feld ist das Recht, das der Eintrag braucht — `null` heisst
   „steht jedem offen". Es kam am 25.08.2026 dazu: der Kunde hat beim Test
   gemeldet, im „Neu"-Menue staenden Eintraege, mit denen er nichts anfangen
   kann. Ein Menue, dessen Eintraege in einer Fehlermeldung enden, ist
   schlimmer als ein kuerzeres — man probiert sie beim naechsten Mal wieder.
   Die Seitenleiste blendet aus, was das Konto nicht darf, und was in ein
   abgeschaltetes Modul fuehrt. */
export const NEU_ARTEN: [label: string, ziel: string, recht: string | null][] = [
  ['Rolle', '/rollen/bearbeiten?neu=1', 'rollen.anlegen'],
  ['Applikation', 'form:applikation', 'assets.schreiben'],
  ['Technische Gruppe', 'form:gruppe', 'gruppen.schreiben'],
  ['Laufwerk', 'form:laufwerk', 'assets.schreiben'],
  ['Postfach', 'form:postfach', 'assets.schreiben'],
  ['Ich möchte … (Aufgabe wählen)', 'wegweiser', null],
];

/* „Abmelden" steht hier bewusst **nicht** mehr.

   Es war ein Verweis auf `/anmelden` — eine Route, die es nie gab. Der Nutzer
   landete auf „Nicht gefunden" und blieb angemeldet. Abmelden ist auch keine
   Navigation, sondern eine Handlung; es gehoert als Schaltflaeche gerendert,
   nicht als Verweis. Die Kopfzeile haengt es unter diese Liste. */
export const KONTO_EINTRAEGE: [label: string, href: string][] = [
  ['Mein Profil', '/profil'],
  /* „Meine Zugriffe" stand hier bis zum 27.08.2026 und führte auf
     `/personen/P-008` — eine **feste fremde** Personenkennung, für jeden
     Nutzer dieselbe. Bei HOWOGE ist die Route über den Mandantenzuschnitt
     gesperrt und endete in „Nicht Teil dieses Mandanten"; bei COMLINE und
     DEV zeigte sie die Zugriffe einer anderen Person als die eigenen.

     Dieselbe Klasse wie das „Abmelden" auf `/anmelden`, dessen Entfernung
     der Kommentar darüber beschreibt. Wiederkommen kann der Eintrag, sobald
     `/api/ich` eine Personenkennung führt — heute führt es keine. */
  ['Meine Anträge', '/antraege/meine'],
  ['Tastenkürzel', '/profil?tab=kuerzel'],
];

/**
 * Mandanten, zwischen denen der Kopf wechseln lässt.
 *
 * Zwei Fälle, und sie schließen einander aus:
 *
 *   - **Instanz mit festem Mandanten** (`VITE_MANDANT`, siehe `instanz.ts`):
 *     genau ein Eintrag. Die Kopfzeile blendet die Wahl dann aus — ein
 *     Umschalter mit einem Ziel ist eine Schaltfläche, die nichts tut.
 *   - **Instanz mit mehreren Mandanten**: die Wahl steht offen.
 *
 * Der Name kommt aus `PROFILE`, nicht aus einer zweiten Liste. Zwei Listen
 * für dieselbe Sache laufen auseinander; die erste Fassung dieser Datei tat
 * genau das und führte HOWOGE noch, als das Profil längst weg war.
 */
export const MARKEN: [schluessel: string, label: string][] =
  INSTANZ_MANDANT === null
    ? (['comline', 'dev'] as const).map(
        (k): [string, string] => [k, PROFILE[k]?.name ?? k.toUpperCase()],
      )
    : [[INSTANZ_MANDANT, PROFILE[INSTANZ_MANDANT]?.name ?? INSTANZ_MANDANT.toUpperCase()]];

/** Nur Hell und Dunkel — ein Systemmodus verwirrt mehr, als er hilft. */
export const THEMES: [schluessel: string, label: string, icon: string][] = [
  ['light', 'Hell', 'sonne'],
  ['dark', 'Dunkel', 'mond'],
];

/** Das Logo trägt in beiden Marken die feste Primärfarbe der Marke. */
export const LOGOFARBE: Record<string, string> = {
  comline: '#D84F22',
  howoge: '#009EE3',
  dev: '#5B8C6E',
};

/**
 * Die drei Balken des Logos: `[x, y, breite, hoehe, deckkraft]` in einem
 * 26 × 26 großen Feld.
 *
 * Sie standen bis zum 27.08.2026 nur als JSX in der Kopfzeile. Seit der
 * HTML-Bericht dasselbe Zeichen trägt, stehen sie hier — eine Abschrift
 * liefe auseinander, sobald jemand eine der beiden anfasst.
 */
export const LOGOBALKEN: [x: number, y: number, b: number, h: number, deckung: number][] = [
  [1, 4, 7, 18, 1],
  [10, 9, 7, 13, 0.72],
  [19, 14, 6, 8, 0.45],
];

/**
 * Die Wortmarke der HOWOGE.
 *
 * ## Warum sie hier nachgebaut ist
 *
 * Der Kunde will oben links seine eigene Marke sehen, nicht unser Zeichen
 * (03.09.2026). Das Corporate-Design-PDF traegt das Logo als Vektorinhalt in
 * einem 21-KB-Strom; in dieser Umgebung gibt es keinen PDF-Renderer, um es
 * herauszuloesen. Der Kunde hat es daraufhin als Bild geschickt und um einen
 * Nachbau gebeten.
 *
 * **Was hier steht, ist ein Nachbau und nicht die Originaldatei:** die
 * Flaeche stimmt in Form und Farbe (dieselbe wie `LOGOFARBE.howoge`), die
 * Wortmarke ist in einem Schriftstapel gesetzt und nicht als Pfad. Auf einem
 * Rechner ohne die Hausschrift weicht die Buchstabenform leicht ab.
 *
 * Sobald die echte SVG-Datei vorliegt, ist der Austausch eine Zeile: der
 * Rumpf von `hausmarkeSvg` wird ersetzt, die Aufrufer bleiben. Genau dafuer
 * steht die Geometrie hier und nicht als JSX in der Kopfzeile.
 *
 * ## Die Form
 *
 * Rechteck 3:1, unten links stark gerundet — der Radius ist 60 Prozent
 * der Hoehe. Die drei anderen Ecken bleiben spitz; das ist das
 * Erkennungsmerkmal und keine Nachlaessigkeit.
 */
export function hausmarkeSvg(hoehe = 26): string {
  const breite = Math.round(hoehe * 3);
  const farbe = LOGOFARBE['howoge'] ?? '#009EE3';
  return `<svg width="${breite}" height="${hoehe}" viewBox="0 0 300 100" `
    + `role="img" aria-label="HOWOGE">`
    + `<path d="M0 0H300V100H60A60 60 0 0 1 0 40Z" fill="${farbe}"/>`
    /* Grundlinie 67 und nicht 52: die Versalhoehe einer Groteske betraegt
       rund 72 Prozent des Schriftgrads, hier also 33 von 46. Bei y=52
       standen die Versalien von 19 bis 52, ihre Mitte also bei 35 statt
       bei 50 — deutlich zu hoch im Feld. Der Kunde hat es gesehen.
       Gerechnet: (100 - 33) / 2 + 33 = 66,6. */
    + `<text x="150" y="67" text-anchor="middle" `
    + `fill="#FFFFFF" font-size="46" font-weight="700" letter-spacing="1" `
    + `font-family="Archivo,'IBM Plex Sans','Segoe UI',system-ui,sans-serif"`
    + `>HOWOGE</text></svg>`;
}
/** Das Logo als SVG-Zeichenkette — für alles außerhalb von React. */
export function logoSvg(farbe: string, groesse = 26): string {
  const balken = LOGOBALKEN
    .map(([x, y, b, hh, d]) =>
      `<rect x="${x}" y="${y}" width="${b}" height="${hh}" rx="2" `
      + `fill="${farbe}" opacity="${d}"/>`)
    .join('');
  return `<svg width="${groesse}" height="${groesse}" viewBox="0 0 26 26" `
    + `aria-hidden="true">${balken}</svg>`;
}

/* ---------------------------------------------------------- Stilhelfer */

export const segStil = (aktiv: boolean): string =>
  'padding:0 10px;background:' + (aktiv ? 'var(--brand-primary-subtle)' : 'transparent') +
  ';color:' + (aktiv ? 'var(--brand-strong)' : 'var(--text-secondary)') +
  ';border:none;cursor:pointer;font-size:12px;font-weight:' + (aktiv ? '600' : '400') +
  ';display:grid;place-items:center';
